import { render, staticRenderFns } from "./DragIcon.vue?vue&type=template&id=b983ccf0&"
import script from "./DragIcon.vue?vue&type=script&lang=js&"
export * from "./DragIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports